import { call } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { RTCClient } from 'utils/webrtc';
import { signalingScreenshareWhiteboardUpdated } from 'features/content-whiteboard/actions';
import {
  contentBoard,
  type ContentWhiteboardRemoteUpdateData,
} from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* onScreenshareWhiteboardUpdatedSaga(
  action: ReturnType<typeof signalingScreenshareWhiteboardUpdated>
) {
  const data: ContentWhiteboardRemoteUpdateData = {
    changed: [],
    removed: [],
  };

  try {
    data.removed = action.payload.removed;
    data.changed = action.payload.changed.map((row: any) => JSON.parse(row.data));

    if (RTCClient.localFeeds[action.payload.feedId]) {
      yield call(contentBoard.updateLocalScreenshareState, data);
    }

    if (contentBoard.type !== 'screenshare' || contentBoard.id !== action.payload.feedId) {
      return;
    }

    yield call(contentBoard.acceptRemoteChanges, data);
  } catch (error) {
    Sentry.captureException(error);
  }
}
